import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
// import * as FileSaver from 'file-saver';
// const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private apiCallTriggerSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  loaderTrigger: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  getVoucherPrintData = new BehaviorSubject<any>(null);
  getVoucherPrintData$: Observable<any> = this.getVoucherPrintData.asObservable();


  printTaxCertificate = new BehaviorSubject<any>({ contractId: null, purchaseId: null });
  printTaxCertificate$: Observable<any> = this.printTaxCertificate.asObservable();


  constructor(private http: HttpClient, private snackBar: MatSnackBar) {}

  setApiCallTrigger(value: boolean) {
    this.apiCallTriggerSubject.next(value);
    localStorage.setItem('get-menu', 'true');
  }

  getApiCallTrigger(): Observable<boolean> {
    return this.apiCallTriggerSubject.asObservable();
  }

  getLoaderTrigger() {
    return this.loaderTrigger.asObservable();
  }


  // ASSST FILE DOWNLOAD

  downloadFile(filename: string): void {
    const filePath = `assets/Files/${filename}`;

    this.http.get(filePath, { responseType: 'blob' }).subscribe((data: Blob) => {
      const blob = new Blob([data], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }


  postInformationFormData(url: string, data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      })
    };
    return this.http.post(`${environment.baseUrl}${url}`, data);
  }

  getmyupLoadtask() {
    return this.http.get<any>(environment.baseUrl + 'Uploader/getmyuploadtask');
  }

  getAllUploadTasksByRequestType(requestType: string) {
    const params = new HttpParams().set('requesttype', requestType);
    return this.http.get<any>(environment.baseUrl + 'Uploader/getalluploadtasksbyrequesttype', {
      params,
    });
  }


  // FILE DOWNLOAD FROM BACKED
  fileDownload(taskId: any , name='example' ) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/xlsx',
        responseType: 'blob',
        Accept: 'application/xlsx',
        observe: 'response'
      })
    };
    this.http.get(environment.baseUrl + 'Uploader/downloadfile?taskid=' + taskId, { responseType: 'blob' }).subscribe((response: Blob) => {
      // Create a blob object with the response data
      const blob = new Blob([response], { type: 'application/octet-stream' });

      // Create a link element to trigger the download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}-${new Date().getTime()}.xlsx`; // Specify the file name

      // Trigger the download
      link.click();

      // Clean up
      window.URL.revokeObjectURL(link.href);
    }, (err) => {
      console.log(err);
      if (err?.status === 500) {
        this.snackBar.open('Something went wrong , please retry', 'Close', {
          duration: 6000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        return;
      }
      const blob = new Blob([err?.error?.text], { type: 'application/octet-stream' });

      // Create a link element to trigger the download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'example.xlsx'; // Specify the file name

      // Trigger the download
      link.click();

      // Clean up
      window.URL.revokeObjectURL(link.href);
    });
  }

  downloadExcelFile(param: any, apiURL: string): Observable<Blob> {
    return this.http.get(environment.baseUrl + apiURL, {params: param, responseType: 'blob' });
  }

  // FILE EXPORT TO EXCEL
  exportToExcel(data: any[], filename: string): void {
    // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    // XLSX.writeFile(wb, filename + '.xlsx');

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Customize column headers for each column
    const headerStyle = {
      font: { bold: true, sz: 22, name: 'Arial' }, // Make the header text bold, set the font size to 14, and specify the font family (adjust as needed)
      alignment: { horizontal: 'center' }, // Center-align the header text
    };

    // Increase the width of each column and apply the header style
    for (let col = 1; col <= data[0].length; col++) {
      ws[XLSX.utils.encode_cell({ c: col - 1, r: 0 })].s = headerStyle;

      // Check if the !cols property exists before accessing it
      if (!ws['!cols']) {
        ws['!cols'] = [];
      }

      // Increase the width of the column (e.g., all columns) - Adjust the width as needed
      ws['!cols'][col - 1] = { wch: 22 };
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename + '.xlsx');
  }

  uploadsubmitWorkflow(id: any) {
    return this.http.get<any>(environment.baseUrl + 'Uploader/uploadsubmitworkflow?taskid=' + id);
  }

  getBankGenerationDataForExportById(id: any) {
    return this.http.get<any>(environment.baseUrl + 'CashOverCounter/GetBankGenerationDataForExportById?RequestId=' + id);
  }

  // exportAsExcelFile(data: any[], excelFileName: string): void {
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, { header: [""] });

  //   // Create headers with two rows
  //   const header1 = ["Internal Grade", "Opening Balance", "Quantity Purchased", "Quantity Issued", "Closing Balance", "In-Transit to the Location"];
  //   const header2 = ["", "Bales", "KGs", "Bales", "KGs", "Bales", "KGs", "Bales", "KGs", "Bales", "KGs"];

  //   // Combine the headers
  //   XLSX.utils.sheet_add_aoa(worksheet, [header1], { origin: 'A1' });
  //   XLSX.utils.sheet_add_aoa(worksheet, [header2], { origin: 'A2' });

  //   // Add data starting from the third row
  //   XLSX.utils.sheet_add_json(worksheet, data, { skipHeader: true, origin: 'A3' });

  //   const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  // }

  exportAsExcelFile(data: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Create headers with two rows
    const header1 = ["Internal Grade", "Opening Balance", "", "Quantity Purchased", "", "Quantity Issued", "", "Closing Balance", "", "In-Transit to the Location", ""];
    const header2 = ["", "Bales", "KGs", "Bales", "KGs", "Bales", "KGs", "Bales", "KGs", "Bales", "KGs"];

    // Combine the headers
    XLSX.utils.sheet_add_aoa(worksheet, [header1], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [header2], { origin: 'A2' });

    // Add data starting from the third row
    XLSX.utils.sheet_add_json(worksheet, data, { skipHeader: true, origin: 'A3' });

    // Merge cells for the main headers
    worksheet['!merges'] = [
      { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
      { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
      { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
      { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } },
      { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
    ];

    // Set column widths
    worksheet['!cols'] = [
      { wch: 15 }, // Column A - Internal Grade
      { wch: 15 }, // Column B - Opening Balance Bales
      { wch: 15 }, // Column C - Opening Balance KGs
      { wch: 15 }, // Column D - Quantity Purchased Bales
      { wch: 15 }, // Column E - Quantity Purchased KGs
      { wch: 15 }, // Column F - Quantity Issued Bales
      { wch: 15 }, // Column G - Quantity Issued KGs
      { wch: 15 }, // Column H - Closing Balance Bales
      { wch: 15 }, // Column I - Closing Balance KGs
      { wch: 15 }, // Column J - In-Transit to the Location Bales
      { wch: 15 }  // Column K - In-Transit to the Location KGs
    ];

    // Apply styles
    this.applyStyles(worksheet);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  exportAsExcelFileAverage(data: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Create headers with two rows
    const header1 = ["", "", "", "", "To - DAY", "", "", "", "", "", "To - DATE", "", "", ""];
    const header2 = ["Tobacco Type", "Grade", "Bales", "KGs", "Amount", "Average", " %", " KGs/Bale", "Bales", "KGs", "Amount", "Average", " %", " KGs/Bale",];

    // Combine the headers
    XLSX.utils.sheet_add_aoa(worksheet, [header1], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [header2], { origin: 'A2' });

    // Add data starting from the third row
    XLSX.utils.sheet_add_json(worksheet, data, { skipHeader: true, origin: 'A3' });

    // Merge cells for the main headers
    // worksheet['!merges'] = [
    //   { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
    //   { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
    //   { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
    //   { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } },
    //   { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
    // ];

    // Set column widths
    worksheet['!cols'] = [
      { wch: 15 }, // Column A - Internal Grade
      { wch: 15 }, // Column B - Opening Balance Bales
      { wch: 15 }, // Column C - Opening Balance KGs
      { wch: 15 }, // Column D - Quantity Purchased Bales
      { wch: 15 }, // Column E - Quantity Purchased KGs
      { wch: 15 }, // Column F - Quantity Issued Bales
      { wch: 15 }, // Column G - Quantity Issued KGs
      { wch: 15 }, // Column H - Closing Balance Bales
      { wch: 15 }, // Column I - Closing Balance KGs
      { wch: 15 }, // Column J - In-Transit to the Location Bales
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
    ];

    // Apply styles
    this.applyStyles(worksheet);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  exportAsExcelFileLeaf(data: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Create headers with two rows
    const header1 = ["", "", "", "", "To - DAY", "", "", "", "", "", "To - DATE", "", "", ""];
    const header2 = ["Tobacco Type", "Location", "Bales", "KGs", "Amount", "Average", " %", " KGs/Bale", "Bales", "KGs", "Amount", "Average", " %", " KGs/Bale",];

    // Combine the headers
    XLSX.utils.sheet_add_aoa(worksheet, [header1], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [header2], { origin: 'A2' });

    // Add data starting from the third row
    XLSX.utils.sheet_add_json(worksheet, data, { skipHeader: true, origin: 'A3' });

    // Merge cells for the main headers
    // worksheet['!merges'] = [
    //   { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
    //   { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
    //   { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
    //   { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } },
    //   { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
    // ];

    // Set column widths
    worksheet['!cols'] = [
      { wch: 15 }, // Column A - Internal Grade
      { wch: 15 }, // Column B - Opening Balance Bales
      { wch: 15 }, // Column C - Opening Balance KGs
      { wch: 15 }, // Column D - Quantity Purchased Bales
      { wch: 15 }, // Column E - Quantity Purchased KGs
      { wch: 15 }, // Column F - Quantity Issued Bales
      { wch: 15 }, // Column G - Quantity Issued KGs
      { wch: 15 }, // Column H - Closing Balance Bales
      { wch: 15 }, // Column I - Closing Balance KGs
      { wch: 15 }, // Column J - In-Transit to the Location Bales
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
    ];

    // Apply styles
    this.applyStyles(worksheet);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }



  exportAsExcelFileInventory(data: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Create headers with two rows
    const header1 = ["", "", "To - DAY", "", "", "", "To - DATE", "", "", ""];
    const header2 = ["Tobacco Type", "Grade", "Sap Material Code", "Opening KGs", "Purchased KGs", "Processed KGs", "Closing KGs", "Opening KGs", "Purchased KGs", "Processed KGs", "Closing KGs" ];

    // Combine the headers
    XLSX.utils.sheet_add_aoa(worksheet, [header1], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [header2], { origin: 'A2' });

    // Add data starting from the third row
    XLSX.utils.sheet_add_json(worksheet, data, { skipHeader: true, origin: 'A3' });

    // Merge cells for the main headers
    // worksheet['!merges'] = [
    //   { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
    //   { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
    //   { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
    //   { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } },
    //   { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
    // ];

    // Set column widths
    worksheet['!cols'] = [
      { wch: 15 }, // Column A - Internal Grade
      { wch: 15 }, // Column B - Opening Balance Bales
      { wch: 15 }, // Column C - Opening Balance KGs
      { wch: 15 }, // Column D - Quantity Purchased Bales
      { wch: 15 }, // Column E - Quantity Purchased KGs
      { wch: 15 }, // Column F - Quantity Issued Bales
      { wch: 15 }, // Column G - Quantity Issued KGs
      { wch: 15 }, // Column H - Closing Balance Bales
      { wch: 15 }, // Column I - Closing Balance KGs
      { wch: 15 }, // Column J - In-Transit to the Location Bales
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
      { wch: 15 },  // Column K - In-Transit to the Location KGs
    ];

    // Apply styles
    this.applyStyles(worksheet);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  private applyStyles(worksheet: XLSX.WorkSheet): void {
    const headerCellStyle = {
      fill: {
        fgColor: { rgb: "FFFF00" } // Yellow background
      },
      font: {
        bold: true,
        siz: 20
      },
    };

    const rowCellStyle = {
      fill: {
        fgColor: { rgb: "FF0000" } // Red background
      }
    };

    // Apply header styles
    for (let col = 0; col < 3; col++) {
      worksheet[XLSX.utils.encode_cell({ r: 0, c: col })].s = headerCellStyle; // First row
      worksheet[XLSX.utils.encode_cell({ r: 1, c: col })].s = headerCellStyle; // Second row
    }

    // Apply row styles (starting from row 3, index 2)
    for (let row = 2; row < Object.keys(worksheet).length; row++) {
      for (let col = 0; col < 3; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (worksheet[cellAddress]) {
          worksheet[cellAddress].s = rowCellStyle;
        }
      }
    }
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    var FileSaver = require('file-saver');
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
